<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,15C16,14.72,15.88,14.48,15.69,14.31C15.69,14.31,15.71,14.29,15.71,14.29C15.71,14.29,12.59,11.17,12.59,11.17C12.59,11.17,16,10.33,16,10.33C16,10.33,7.95,7.47,7.95,7.47C7.98,7.38,8,7.3,8,7.2C8,7.2,8,2,8,2C8,1.45,7.55,1,7,1C7,1,3,1,3,1C3,0.45,2.55,0,2,0C1.45,0,1,0.45,1,1C0.45,1,0,1.45,0,2C0,2.55,0.45,3,1,3C1,3,1,7,1,7C1,7.55,1.45,8,2,8C2,8,7.2,8,7.2,8C7.3,8,7.38,7.98,7.47,7.95C7.47,7.95,10.33,16,10.33,16C10.33,16,11.18,12.59,11.18,12.59C11.18,12.59,14.3,15.71,14.3,15.71C14.3,15.71,14.32,15.69,14.32,15.69C14.48,15.88,14.72,16,15,16C15.04,16,15.07,15.98,15.1,15.98C15.13,15.98,15.16,16,15.2,16C15.64,16,16,15.64,16,15.2C16,15.16,15.98,15.13,15.98,15.1C15.98,15.07,16,15.04,16,15C16,15,16,15,16,15ZM6,6C6,6,3,6,3,6C3,6,3,3,3,3C3,3,6,3,6,3C6,3,6,6,6,6C6,6,6,6,6,6Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Select',
} as DefineComponent
</script>
